if ($("#createwaitlistform").length > 0) {
    // only on waitlist page

    var AgeGroupEnum = { Infant: "1", Preschool: "2", SchoolAge: "3" };
    var StartDateEnum = { NotSelected: "-1", Immediately: "1", Preferred: "2" };

    var jsAgeGroup = "";
    var jsRegisteredForSchool = "";
    var jsIsNotDropIn = false;
    var jsChildNotYetBorn = "";
    var jsStartDate = "";
    var jsClientInteraction = 0;
    

    $('.select2').select2({
        allowClear: true,
        multiple: true,
        language: '@Labels.LangCode',
        dropdownAutoWidth: true,
        // placeholder: '@SearchLabels.All',
        width: '100%',
        selectionCssClass: 'highlighted'
    });


    if (window.history && history.pushState) {
        addEventListener('load', function () {
            history.pushState(null, null, null); // creates new history entry with same URL
            var stayOnPage
            addEventListener('popstate', function () {
                $("#CancelModal").modal();
                $("#btnNo").on('click')
                {
                    stayOnPage = true;
                }
                if (!stayOnPage) {
                    history.back()
                } else {
                    history.pushState(null, null, null);
                }
            });
        });
    }


    //chkSelectAll
    $("#chkSelectAll").on("change", function () {

        if (this.checked === true) {
            $('.tick').each(function () {
                if ($(this).is(':visible')) this.checked = true; // don't check if not visible, screws up database
            });
        }
        else if (this.checked === false) {
            $('.tick').each(function () {
                if ($(this).is(':visible')) this.checked = false; // don't check if not visible, screws up database
            });
        };

        // uncheck any boxes not visible, just in case they switched options
        $("#chkboxes input[type=checkbox]:hidden:checked").trigger('click');
    });

    $(".tick").on("change", function () {
        // uncheck any boxes not visible, just in case they switched options
        $("#chkboxes input[type=checkbox]:hidden:checked").trigger('click');
    });


    function HandleFrequencyOptions(day) {

    }

    function SetTab(index, isLoad) {
        if (index == 0) {
            $("#IdDetailsTab").tab("show");

            //// Also need to clear the child error and validation errors if user goes back a tab
            //if (!isLoad) {
            //    $("span.field-validation-error").html("");
            //    var errorConfirmSection = $("#ErrorConfirmSection");
            //    if (errorConfirmSection) {
            //        errorConfirmSection.addClass("d-none");
            //        $("#IsErrorConfirmed").prop("checked", false);
            //        $("#IsErrorConfirmed").change();
            //    }
            //}

            $("#IdFrequencyTab").removeClass("complete");
            $("#IdFrequencyTab").addClass("disabled");
            $("#IdPreferencesTab").removeClass("complete");
            $("#IdPreferencesTab").addClass("disabled");

        } else if (index == 1) {
            $("#IdFrequencyTab").addClass("complete");
            $("#IdFrequencyTab").removeClass("disabled");
            $("#IdFrequencyTab").prop("disabled", false);
            $("#IdFrequencyTab").attr("disabled", false);
            $("#IdFrequencyTab").removeProp("disabled");
            $("#IdFrequencyTab").tab("show");

            $("#IdPreferencesTab").removeClass("complete");
            $("#IdPreferencesTab").addClass("disabled");

        } else if (index == 2) {
            $("#IdPreferencesTab").addClass("complete");
            $("#IdPreferencesTab").removeClass("disabled");
            $("#IdPreferencesTab").removeClass("d-none");
            $("#IdPreferencesTab").tab("show");
            $("#IdPreferencesTab").prop("disabled", false);
            $("#IdPreferencesTab").removeProp("disabled");
            $("#IdPreferencesTab").attr("disabled", false);

        }

        if (!isLoad) {
            //$('.mobiledd div.content').html($(".mdc").html());
            //$('.mobiledd span.content').html($('.mobiledd a.active:last').text());
        }
    }

    $("#IdDetailsTab, #btnFrequencyPrevious").click(function () {
        SetTab(0);
    });


    $("#IdFrequencyTab, #btnPreferencesPrevious").click(function () {
        SetTab(1);
    });

    $("#IdPreferencesTab").click(function () {
        SetTab(2);
    });

    $("#btnPreferencesSave").on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        var isValid = true;

        if ($("#SelectedCommunities").val().length <= 0) {
            $("#SelectedCommunities-error").removeClass('d-none');
            isValid = false;
        } else {
            $("#SelectedCommunities-error").addClass('d-none');
        }

        if (!$("#id_PreferenceFacilityCenter, #id_PreferenceFacilityHome").is(":checked")) {
            $("#FacilityCenter-error").removeClass('d-none');
            isValid = false;
        } else {
            $("#FacilityCenter-error").addClass('d-none');
        }

        if (jsAgeGroup != AgeGroupEnum.SchoolAge) {
            if (!$("#id_PreferencesDesignatedYes, #id_PreferencesDesignatedNo").is(":checked")) {
                $("#PreferencesDesignatedYes-error").removeClass('d-none');
                isValid = false;
            } else {
                $("#PreferencesDesignatedYes-error").addClass('d-none');
            }
        }


        if (!$("#id_PreferenceFrench, #id_PreferenceEnglish").is(":checked")) {
            $("#PreferenceEnglish-error").removeClass('d-none');
            isValid = false;
        } else {
            $("#PreferenceEnglish-error").addClass('d-none');
        }

        if (isValid) {
            $("#createwaitlistform").submit();
        }
    });

    function ValidateChildDetails() {
        //Check if a child has been selected
        var isValid = $("#children-box input:checked").length > 0; // the future dob child is ID = 0

        if (!isValid) {
            $("#ChildId-error").removeClass("d-none");
        }
        else {
            $("#ChildId-error").addClass("d-none");
        }

        //Need to check if the child is already on a waitlist
        isValid = isValid && jsExistingwaitlist == false;

        return isValid;
    }

    function ValidateDropInService() {
        var isValid = true;

        //Drop in service option selected?
        if (!$("#id_FrequencyRegularScheduleYes").is(":checked")
            && !$("#id_FrequencyRegularScheduleNo").is(":checked")) {
            isValid = isValid && false;
            $("#FrequencyRegularSchedule-error").removeClass("d-none");
        }
        else {
            $("#FrequencyRegularSchedule-error").addClass("d-none");
        }


        //Does the child attend on regular basis?
        if (jsIsNotDropIn) {
            //Need to select at least one day and AM or PM
            var sumTicked = 0;
            $('.tickam, .tickpm, .tick').each(function () {
                if (this.checked === true) {
                    sumTicked += 1;
                }
            });

            //Is at least one checkbox selected?
            if (sumTicked == 0) {
                isValid = isValid && false;
                $("#DayOfWeek-error").removeClass("d-none");
            }
            else {
                $("#DayOfWeek-error").addClass("d-none");
            }

            //willing to receive an offer?
            if (!$("#id_FrequencyOffSomeDaysNo").is(":checked")
                && !$("#id_FrequencyOffSomeDaysYes").is(":checked")) {
                isValid = isValid && false;
                $("#FrequencyOffSomeDays-error").removeClass("d-none");
            }
            else {
                $("#FrequencyOffSomeDays-error").addClass("d-none");
            }
        }

        return isValid;
    }

    function ValidateServiceStartCd() {
        var isValid = true;
        var ServiceStartCd = $("#ServiceStartCd option:selected").val();

        if (ServiceStartCd == StartDateEnum.NotSelected) {
            //The user needs to select a date
            isValid = isValid && false;
            $("#ServiceStartCd-error").removeClass("d-none");
        }
        else {
            $("#ServiceStartCd-error").addClass("d-none");

            var usePreferredDate = ServiceStartCd == StartDateEnum.Preferred;
            var preferredStartDate = moment($("#PreferredStart").val(), 'YYYY-MM-DD');

            //Should we use the preferred date?
            if (!usePreferredDate) {
                preferredStartDate = moment(); //Default to the current date
            }

            //Check if the entered date is valid
            if (usePreferredDate && !moment(preferredStartDate).isValid()) {
                isValid = isValid && false;

                //Need to trigger validation
                $('#PreferredStart').valid();

            }

        }

        return isValid;
    }

    function ValidateFrequency() {
        var isValid = true;

        if (jsAgeGroup == AgeGroupEnum.Infant) {
            //Validate preferred date
            isValid = $("#PreferredStart").valid() && isValid;

            //Validate the drop in services
            //Call the validation function first so the
            //to ensure that it is called regardless of the
            //value of isValid
            isValid = ValidateDropInService(false) && isValid;
        }

        if (jsAgeGroup == AgeGroupEnum.Preschool) {
            //Validate the preferred start date
            isValid = ValidateServiceStartCd() && isValid;

            //Validate the drop in services
            //Call the validation function first so the
            //to ensure that it is called regardless of the
            //value of isValid
            isValid = ValidateDropInService(false) && isValid;

            //validate FrequencyAttendSchool-error
            var isFrequencyAttendSchoolYes = $("#id_FrequencyAttendSchoolStartYes").is(":checked");
            var isFrequencyAttendSchoolNo = $("#id_FrequencyAttendSchoolStartNo").is(":checked");
            if (isFrequencyAttendSchoolYes || isFrequencyAttendSchoolNo) {
                $("#FrequencyAttendSchoolStart-error").addClass("d-none");
            }
            else if ($("#id_FrequencyAttendSchoolStartYes, #id_FrequencyAttendSchoolStartNo").is(":visible")) {
                isValid = isValid && false;
                $("#FrequencyAttendSchoolStart-error").removeClass("d-none");
            }
        }

        if (jsAgeGroup == AgeGroupEnum.SchoolAge) {
            //Validate the preferred start date
            isValid = ValidateServiceStartCd() && isValid;

            //validate FrequencyAttendSchool-error
            var isFrequencyAttendSchoolYes = $("#id_FrequencyAttendSchoolYes").is(":checked");
            var isFrequencyAttendSchoolNo = $("#id_FrequencyAttendSchoolNo").is(":checked");
            if (isFrequencyAttendSchoolYes || isFrequencyAttendSchoolNo) {
                $("#FrequencyAttendSchool-error").addClass("d-none");
            }
            else if ($("#id_FrequencyAttendSchoolYes, #id_FrequencyAttendSchoolNo").is(":visible")) {
                isValid = isValid && false;
                $("#FrequencyAttendSchool-error").removeClass("d-none");
            }



            //validate FrequencyAttendSchoolStart
            var isFrequencyAttendSchoolStartYes = $("#id_FrequencyAttendSchoolStartYes").is(":checked");
            var isFrequencyAttendSchoolStartNo = $("#id_FrequencyAttendSchoolStartNo").is(":checked");
            if (isFrequencyAttendSchoolStartYes || isFrequencyAttendSchoolStartNo) {
                $("#FrequencyAttendSchoolStart-error").addClass("d-none");
            }
            else if ($("#id_FrequencyAttendSchoolStartYes, #id_FrequencyAttendSchoolStartNo").is(":visible")) {
                isValid = isValid && false;
                $("#FrequencyAttendSchoolStart-error").removeClass("d-none");
            }


            //validate FrequencyAttendSchoolStart
            var isFrequencyRequireBeforeAfterYes = $("#id_FrequencyRequireBeforeAfterYes").is(":checked");
            var isFrequencyRequireBeforeAfterNo = $("#id_FrequencyRequireBeforeAfterNo").is(":checked");
            if (isFrequencyRequireBeforeAfterYes || isFrequencyRequireBeforeAfterNo) {
                $("#FrequencyRequireBeforeAfter-error").addClass("d-none");
            }
            else if ($("#id_FrequencyRequireBeforeAfterYes, #id_FrequencyRequireBeforeAfterNo").is(":visible")) {
                isValid = isValid && false;
                $("#FrequencyRequireBeforeAfter-error").removeClass("d-none");
            }

            //Validate the drop in services
            //Call the validation function first so the
            //to ensure that it is called regardless of the
            //value of isValid
            isValid = ValidateDropInService(true) && isValid;
        }

        var ServiceStartCd = $("#ServiceStartCd option:selected").val();
        var usePreferredDate = ServiceStartCd == StartDateEnum.Preferred;
        var preferredStartDate = moment($("#PreferredStart").val(), 'YYYY-MM-DD');

        if ($("#PreferredStart").val() != '' && usePreferredDate && moment(preferredStartDate).isValid()) {
            var birthyear = moment(jsChildDOB, 'YYYY-MM-DD');
            jsChildAge = birthyear.diff(moment(preferredStartDate), 'years', true) * -1;

            if (jsChildAge >= 14.0 && jsChildAge < 2000) { // < 2000 covers 0 child age for unborn child
                isValid = isValid && false;
                $("#PreferredStartAge-error").removeClass("d-none");
            } else {
                $("#PreferredStartAge-error").addClass("d-none");
            }
        }

        return isValid;
    }

    $("#btnChildDetailsNext").click(function () {
        //Need to validate the Child Details Form
        if (ValidateChildDetails()) {

            SetTab(1);

            if ($("#id_FrequencyRegularScheduleYes").is(":checked")) {
                $("#id_FrequencyRegularScheduleYes").trigger('change');
            } else if ($("#id_FrequencyRegularScheduleNo").is(":checked")) {
                $("#id_FrequencyRegularScheduleNo").trigger('change');
            }
        }
    });

    $("#btnFrequencyNext").click(function () {
        //Need to validate the Frequency
        if (ValidateFrequency()) {
            SetTab(2);
        }
    });

    //Used to determine the age group of this child
    function ConfigureFrequencyTab(usePreferredDate, preferredStartDate) {

        //If the child isn't born yet then they are an infant
        var jsChildAge = 0;
        var preferredDate;


        if (jsChildNotYetBorn == "true") {
            jsAgeGroup = AgeGroupEnum.Infant;
            usePreferredDate = true;
            jsChildAge = 0;
        } else {
            var timestamp = '';

            //Should we use the preferred date?
            if (!usePreferredDate) {
                preferredStartDate = moment(); //Default to the current date
                preferredDate = moment();
            } else {
                preferredDate = preferredStartDate;
            }

            console.log(preferredStartDate);
            console.log(moment(preferredStartDate).isValid());
            //Is ther preffered date enter valid?
            if (moment(preferredStartDate).isValid()) {
                //Determine the Age Group based on DOB and Preferred Date
                var birthyear = moment(jsChildDOB, 'YYYY-MM-DD');
                jsChildAge = preferredDate.diff(birthyear, 'y');

                if (jsChildAge > 2000) {
                    jsChildAge = 0;
                }

                if (jsChildAge < 2) {
                    jsAgeGroup = AgeGroupEnum.Infant;
                } else if (jsChildAge <= 5) {
                    jsAgeGroup = AgeGroupEnum.Preschool;

                    // override age group if parent clicked does attend school
                    if ($("#id_FrequencyAttendSchoolYes").is(":checked")) {
                        jsAgeGroup = AgeGroupEnum.SchoolAge;
                    }
                    if ($("#id_FrequencyAttendSchoolStartYes").is(":checked")) {
                        jsAgeGroup = AgeGroupEnum.SchoolAge;
                    }
                } else if (jsChildAge >= 6) {
                    jsAgeGroup = AgeGroupEnum.SchoolAge;
                } else {
                    jsAgeGroup = AgeGroupEnum.SchoolAge;
                }
            }
            else {
                jsAgeGroup = AgeGroupEnum.Preschool;
                jsChildAge = 3; // set to preschool age
            }

            console.log('jsChildAge = ' + jsChildAge);

            //Store the age group to the Model
            $("#AgeGroupCd").val(jsAgeGroup);
        }

        //Are we entering a preferred date?
        if (usePreferredDate) {
            $(".preferredStartDateDiv").removeClass("d-none");
            $("#Create_FrequencyRegularSchedule2").addClass("d-none");
            $("#Create_FrequencyRegularSchedule").removeClass("d-none");
        }
        else {
            $(".preferredStartDateDiv").addClass("d-none");
            $("#Create_FrequencyRegularSchedule").addClass("d-none");
            $("#Create_FrequencyRegularSchedule2").removeClass("d-none");
        }

        //Are drop ins selected?
        if (jsIsNotDropIn) {
            $(".allowDropIns").removeClass("d-none");
        } else {
            $(".allowDropIns").addClass("d-none");
        }


        console.log('jsAgeGroup == AgeGroupEnum.Infant=' + AgeGroupEnum.Infant);

        if (jsAgeGroup == AgeGroupEnum.Infant) {

            if (jsChildNotYetBorn == "true") {
                //Since the child is not born yet they can't attend immediately
                if ($("#ServiceStartCd").val() != StartDateEnum.Preferred) { // prevent recursive looop
                    $("#ServiceStartCd").val(StartDateEnum.Preferred).change(); // set the code
                }
                $(".FrequencyServiceStartDiv").addClass("d-none");
            } else {
                $(".FrequencyServiceStartDiv").removeClass("d-none");
            }
            $(".FrequencyAttendSchoolDiv").addClass("d-none"); //The child is not in school
            $(".FrequencyAttendSchoolStartDiv").addClass("d-none"); //The child is not in school
            $(".FrequencyRequireBeforeAfterDiv").addClass("d-none"); //The child is not in school
            $(".SchoolNameDiv").addClass("d-none"); //The child is not in school
            $(".IsSchoolAge").addClass("d-none");
            $(".IsPreschool").removeClass("d-none");
            $(".PreferenceDesignatedDiv").removeClass("d-none");
            $(".PreferenceFacility").removeClass("mt-3")
        }

        if (jsAgeGroup == AgeGroupEnum.Preschool) {
            $(".FrequencyServiceStartDiv").removeClass("d-none");
            $(".FrequencyAttendSchoolDiv").addClass("d-none"); //The child is not in school
            $(".FrequencyAttendSchoolStartDiv").addClass("d-none"); //The child is not in school
            $(".FrequencyRequireBeforeAfterDiv").addClass("d-none"); //The child is not in school
            $(".SchoolNameDiv").addClass("d-none"); //The child is not in school
            $(".IsSchoolAge").addClass("d-none");
            $(".IsPreschool").removeClass("d-none");
            $(".PreferenceDesignatedDiv").removeClass("d-none");
            $(".PreferenceFacility").removeClass("mt-3")

            if (jsChildAge >= 4) { // fuzzy area where kid might be in school, might not be
                if ($('#ServiceStartCd').val() == '2') {
                    $(".FrequencyAttendSchoolStartDiv").removeClass("d-none");
                    $(".FrequencyAttendSchoolDiv").addClass("d-none");
                } else if ($('#ServiceStartCd').val() == '1') {
                    $(".FrequencyAttendSchoolStartDiv").addClass("d-none");
                    $(".FrequencyAttendSchoolDiv").removeClass("d-none");
                }

                if ($("#id_FrequencyAttendSchoolYes").is(":checked")) {
                    $(".FrequencyRequireBeforeAfterDiv").removeClass("d-none");
                    $(".SchoolNameDiv").removeClass("d-none");
                    $(".IsSchoolAge").removeClass("d-none");
                }

                if ($("#id_FrequencyAttendSchoolStartYes").is(":checked")) {
                    $(".FrequencyRequireBeforeAfterDiv").removeClass("d-none");
                    $(".SchoolNameDiv").removeClass("d-none");
                    $(".IsSchoolAge").removeClass("d-none");
                }
            }

        }

        if (jsAgeGroup == AgeGroupEnum.SchoolAge) {
            $(".FrequencyServiceStartDiv").removeClass("d-none");

            $(".FrequencyAttendSchoolDiv").removeClass("d-none");
            $(".FrequencyAttendSchoolStartDiv").removeClass("d-none");
            $(".PreferenceDesignatedDiv").addClass("d-none");
            $(".PreferenceFacility").addClass("mt-3")

            if (jsChildAge <= 5) { // fuzzy area where kid might be in school, might not be
                if ($('#ServiceStartCd').val() == '2') {
                    $(".FrequencyAttendSchoolStartDiv").removeClass("d-none");
                    $(".FrequencyAttendSchoolDiv").addClass("d-none");
                } else if ($('#ServiceStartCd').val() == '1') {
                    $(".FrequencyAttendSchoolStartDiv").addClass("d-none");
                    $(".FrequencyAttendSchoolDiv").removeClass("d-none");
                }
            } else {
                $(".FrequencyAttendSchoolDiv").addClass("d-none");
                $(".FrequencyAttendSchoolStartDiv").addClass("d-none");
            }

            $(".FrequencyRequireBeforeAfterDiv").removeClass("d-none");
            $(".SchoolNameDiv").removeClass("d-none");
            $(".IsPreschool").addClass("d-none");
            //$(".IsSchoolAge").removeClass("d-none");
        }



        var isRequireBeforeAfterYes = $("#id_FrequencyRequireBeforeAfterYes").is(":checked");
        var isRequireBeforeAfterNo = $("#id_FrequencyRequireBeforeAfterNo").is(":checked") //|| !isRequireBeforeAfterYes; // in case neither is checked

        // if user clicked "No, child not in school or No, won't be in school" we need to override age group
        if ($("#id_FrequencyAttendSchoolNo").is(":checked") || ($("#id_FrequencyAttendSchoolStartNo").is(":checked") && $("#id_FrequencyAttendSchoolStartNo").is(":visible"))) {

            if (jsChildNotYetBorn == "true") {
                jsAgeGroup = AgeGroupEnum.Infant;
            }
            else {
                jsAgeGroup = AgeGroupEnum.Preschool; // not school age
            }

            $(".SchoolAgeFullDay").addClass("d-none");
            $(".SchoolAgeBeforeAfter").addClass("d-none");
            $(".FrequencyRequireBeforeAfterDiv").addClass("d-none");
            $(".SchoolNameDiv").addClass("d-none"); //The child is not in school
            $(".IsPreschool").removeClass("d-none");

            $("#id_FrequencyRequireBeforeAfterNo").prop('checked', false);
            $("#id_FrequencyRequireBeforeAfterYes").prop('checked', false);

            console.log("condition " + 1);
        }
        else if (isRequireBeforeAfterNo && jsChildAge >= 5) {
            jsAgeGroup = AgeGroupEnum.SchoolAge // is school age
            $(".SchoolAgeFullDay").removeClass("d-none");
            $(".SchoolAgeBeforeAfter").addClass("d-none");
            if (jsIsNotDropIn) {
                $(".allowDropIns").removeClass("d-none");
            }
            else
            {
                $(".allowDropIns").addClass("d-none");
            }
            
            console.log("condition " + 2);
        }
        else if (isRequireBeforeAfterNo && jsChildAge < 4) { // is infanct/preschool

            console.log("condition " + 3);
        }
        else if (jsAgeGroup == AgeGroupEnum.Infant && isRequireBeforeAfterYes) {
            $("#id_FrequencyRequireBeforeAfterNo").prop('checked', false);
            $("#id_FrequencyRequireBeforeAfterYes").prop('checked', false);
            $(".SchoolAgeBeforeAfter").addClass("d-none");
            $(".IsPreschool").removeClass("d-none");
        }
        else {
            // above edit broke this case, so instead of re-breaking something else, adding additional logic here
            if (!isRequireBeforeAfterNo && !isRequireBeforeAfterYes && jsChildAge <= 5) {
                $(".SchoolAgeBeforeAfter").addClass("d-none");
                $(".SchoolAgeFullDay").addClass("d-none");
                $(".IsPreschool").removeClass("d-none");
                console.log("condition 4a");
            } else if (isRequireBeforeAfterNo && !isRequireBeforeAfterYes && jsChildAge <= 5) {
                $(".SchoolAgeBeforeAfter").addClass("d-none");
                $(".SchoolAgeFullDay").removeClass("d-none");
                $(".IsPreschool").addClass("d-none");
                console.log("condition 4b");
            } else {
                $(".SchoolAgeBeforeAfter").removeClass("d-none");
                $(".SchoolAgeFullDay").addClass("d-none");
                console.log("condition 4c");
            }
            
        }

        // update Age Group Code value
        $("#AgeGroupCd").val(jsAgeGroup);

        // if user hasn't select frequency yet, hide controls
        if ($("#ServiceStartCd").val() == '-1') {
            $(".FrequencyRequireBeforeAfterDiv").addClass("d-none");
            $(".SchoolNameDiv").addClass("d-none"); //The child is not in school
            $(".FrequencyRegularScheduleDiv").addClass("d-none");
        } else {
            $(".FrequencyRegularScheduleDiv").removeClass("d-none"); // FrequencyRequireBeforeAfterDiv is controlled elsewhere
        }

    } // end ConfigureFrequencyTab

    $("#id_FrequencyAttendSchoolNo, #id_FrequencyAttendSchoolYes").on('change', function () {
        if ($("#id_FrequencyAttendSchoolStartNo").is(":checked")) {
            $("#id_FrequencyAttendSchoolStartNo").trigger('click');
        }
        if ($("#id_FrequencyAttendSchoolStartYes").is(":checked")) {
            $("#id_FrequencyAttendSchoolStartYes").trigger('click');
        }
    });

    $("#id_FrequencyAttendSchoolStartNo, #id_FrequencyAttendSchoolStartYes").on('change', function () {
        if ($("#id_FrequencyAttendSchoolNo").is(":checked")) {
            $("#id_FrequencyAttendSchoolNo").trigger('click');
        }
        if ($("#id_FrequencyAttendSchoolYes").is(":checked")) {
            $("#id_FrequencyAttendSchoolYes").trigger('click');
        }
    });

    $("#ServiceStartCd").on("change", function () {
        var usePreferredDate = this.value == StartDateEnum.Preferred;
        if (!usePreferredDate) {
            $("#PreferredStart").val(moment().format('YYYY-MM-DD'));
        }
        var preferredStartDate = moment($("#PreferredStart").val(), 'YYYY-MM-DD');

        if (jsChildNotYetBorn != 'true') { // if is == true, don't rerun ConfigureFrequencyTab
            ConfigureFrequencyTab(usePreferredDate, preferredStartDate);
        }
    });

    $("#PreferredStart").on("change", function () {
        var usePreferredDate = $("#ServiceStartCd option:selected").val() == StartDateEnum.Preferred;
        var preferredStartDate = moment(this.value, 'YYYY-MM-DD');
        ConfigureFrequencyTab(usePreferredDate, preferredStartDate);
    });

    $("#id_FrequencyAttendSchoolYes, #id_FrequencyAttendSchoolNo, #id_FrequencyAttendSchoolStartYes, #id_FrequencyAttendSchoolStartNo").on("change", function () {
        var usePreferredDate = $("#ServiceStartCd option:selected").val() == StartDateEnum.Preferred;
        var preferredStartDate = moment($("#PreferredStart").val(), 'YYYY-MM-DD');
        ConfigureFrequencyTab(usePreferredDate, preferredStartDate);
    });

    $(".beforeAfterFullday, .dropinRequest").on("change", function () {
        var usePreferredDate = $("#ServiceStartCd option:selected").val() == StartDateEnum.Preferred;
        var preferredStartDate = moment($("#PreferredStart").val(), 'YYYY-MM-DD');

        jsIsNotDropIn = $("#id_FrequencyRegularScheduleYes").is(":checked");

        ConfigureFrequencyTab(usePreferredDate, preferredStartDate);
    });

    $(".child-radiobutton").on("change", function (e) {
        e.preventDefault();
        e.stopPropagation();

        //store this in a global DOB variable
        jsChildDOB = $(this).data("dob");
        jsChildId = $(this).data("id");



        $("#ChildId").val(jsChildId);//Store the Child Id to the Model
        $("#DOB").val(jsChildDOB);//Store the Child DOB to the Model

        CheckExistingWaitlist(jsChildId);

        jsChildNotYetBorn = "" + $(this).data("hidedob").toLowerCase(); //If the hidden flag is set then the child is not yet born // "" + forces string

        // ALM 3435: we're no longer resetting frequency info if the child ID changes.
        var usePreferredDate = false;
        var preferredStartDate = moment($("#PreferredStart").val(), 'YYYY-MM-DD');
        ConfigureFrequencyTab(usePreferredDate, preferredStartDate);
    });

    function ConfigureExistingWaitlist(existingwaitlist, id) {
        //alert(existingwaitlist);

        //Is there an existing waitlist?
        if (existingwaitlist == true) {
            //Display warning message
            $("#ExistingwaitlistDiv").removeClass("d-none");

            $("#ExistingwaitlistDiv a.btn").attr('href', $("#ExistingwaitlistDiv a.btn").data('link') + id);

            //Disable the next button
            $("#btnChildDetailsNext").addClass("disabled");
        }
        else {
            //hide warning message
            $("#ExistingwaitlistDiv").addClass("d-none");

            //enable the next button
            $("#btnChildDetailsNext").removeClass("disabled");
        }


    }

    $(document).ready(function () {
        var usePreferredDate = $("#ServiceStartCd option:selected").value == StartDateEnum.Preferred;
        var preferredStartDate = moment($("#PreferredStart").val(), 'YYYY-MM-DD');
        ConfigureFrequencyTab(usePreferredDate, preferredStartDate);
        SetTab(jsTabIndex, true);

        //trigger existing check on page load if child selected from back button

        window.setTimeout(function () {
            if ($("#children-box input:checked").length > 0) {
                if (jsLastSelectedChild == 0) {
                    jsLastSelectedChild = $("#children-box input:checked").data('id');
                    $("#children-box input:checked").trigger("change");
                }
            }
        }, 100);

        //Commented as part of ALM 3354
        //if (jsIsEdit) {
        //    $("#id_PreferencesDesignatedNo").prop('checked', false);
        //    $("#id_PreferencesDesignatedYes").prop('checked', false);
        //    $("#id_FrequencyOffSomeDaysYes").prop('checked', false);
        //    $("#id_FrequencyOffSomeDaysNo").prop('checked', false);
        //}

    }); 


    if ($("#PreferredStart").val() === "0001-01-01") {
        $("#PreferredStart").val("");
    }

    function ConfigureRegisteredForSchool(registeredForSchool) {
        //alert(registeredForSchool);
    }

    ////Removed 2023-05-18 after discuss TODOs in the technical meeting
    //function ChildRegisteredForSchool(id) {
    //    //TO DO: Create an AJAX call to determine if this child is registered for school
    //    var url = '';

    //    if (location.href.indexOf('/en/') > 0) {
    //        url = location.href.split('/en/')[0] + '/en/child/waitlist/ChildRegisteredForSchool/' + id;
    //    } else {
    //        url = location.href.split('/fr/')[0] + '/fr/child/waitlist/ChildRegisteredForSchool/' + id;
    //    }

    //    $.ajax({
    //        url: url,
    //        method: 'POST',
    //        contentType: false,
    //        processData: false,
    //        success: function (res) {
    //            jsRegisteredForSchool = res.RegisteredForSchool;
    //            ConfigureRegisteredForSchool(jsRegisteredForSchool);
    //        }
    //    });

    //}

    //Check if this child has an existing waitlist
    function CheckExistingWaitlist(id) {

        console.log(jsIsEdit + " - " + id)

        if (jsIsEdit && id == jsEditChildId && jsClientInteraction > 0) { 
            window.location.reload();
            jsClientInteraction++;
            return;
        }

        var url = '';

        if (location.href.indexOf('/en/') > 0) {
            url = location.href.split('/en/')[0] + '/en/child/waitlist/CheckExistingWaitlist/' + id + '?ParentId=' + jsParentId;
        } else {
            url = location.href.split('/fr/')[0] + '/fr/child/waitlist/CheckExistingWaitlist/' + id + '?ParentId=' + jsParentId;
        }

        if (jsWaitlistId > 0) {
            url += "&waitlistApplicationId=" + jsWaitlistId;
        }

        $.ajax({
            url: url,
            method: 'GET',
            contentType: false,
            processData: false,
            success: function (res) {
                jsExistingwaitlist = res.WaitlistExists;
                ConfigureExistingWaitlist(jsExistingwaitlist, res.WaitlistId);
            }
        });
    }

}